import constants from "../../commonUtils/constants";
import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  filters: { keyword: "" },
  ExtExclusionsList: constants.extraction.listInitialState,
  extExclusion: null,
  openModal: false,
  errors: {},
  errorMessage: ""
};

const ExtExclusions = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
      
    case actionTypes.SET_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };
      
    case actionTypes.SET_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    
    case actionTypes.SET_OPEN_MODAL:
      return {
        ...state,
        openModal: action.payload,
        loading: action.payload ? state.loading : false,
        extExclusion: action.payload ? state.extExclusion : null,
      };
    
    case actionTypes.SET_EXT_EXCLUSION:
      return {
        ...state,
        extExclusion: action.payload,
      };
      
    case actionTypes.GET_EXT_EXCLUSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        ExtExclusionsList: action.payload,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.GET_EXT_EXCLUSIONS_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to fetch exclusions"
      };

    case actionTypes.GET_EXT_EXCLUSION_SUCCESS:
      return {
        ...state,
        loading: false,
        extExclusion: action.payload,
        openModal: true,
        errors: {},
        errorMessage: "",
      };
    
    case actionTypes.GET_EXT_EXCLUSION_FAILURE:
      return {
        ...state,
        loading: false,
        openModal: false,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to fetch exclusions"
      };
      
    case actionTypes.CREATE_EXT_EXCLUSION_SUCCESS:
      return {
        ...state,
        loading: false,
        openModal: false,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.CREATE_EXT_EXCLUSION_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors || {},
        errorMessage: action.payload.message || "Failed to create exclusion"
      };
      
    case actionTypes.UPDATE_EXT_EXCLUSION_SUCCESS:
      return {
        ...state,
        loading: false,
        openModal: false,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.UPDATE_EXT_EXCLUSION_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors || {},
        errorMessage: action.payload.message || "Failed to update exclusion"
      };
    
    case actionTypes.UPDATE_EXT_EXCLUSIONS_ORDER_SUCCESS:
      return {
        ...state,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.UPDATE_EXT_EXCLUSIONS_ORDER_FAILURE:
      return {
        ...state,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to update order"
      };
    
    case actionTypes.DELETE_EXT_EXCLUSION_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.DELETE_EXT_EXCLUSION_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to delete exclusion"
      };
      
    default:
      return state;
  }
};

export default ExtExclusions;